import React from 'react'
import OtpInput from 'react-otp-input'
import { fetchAccessToken, sendOTP, validateOtp } from '../login.service'
import styles from '../../styles.module.css'
import { MessageType } from '../constant'
import { NotificationComponent } from '../../Components/notificationWrapper/notificationWrapper'
import { Loader } from '../../Components/loader/loaderView'
class MobileLogin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      enteredNumber: '',
      countryCallingCode: '+91',
      enteredOtp: '',
      showsendOtpForm: true,
      loading: false
    }
  }

  OtpInputChangeHandler = (otp) => {
    this.setState({
      enteredOtp: otp
    })
  }

  mobileInputChangeHandler = (event) => {
    this.setState({
      enteredNumber: event.target.value
    })
  }

  mobileCodeInputChangeHandler = (event) => {
    this.setState({
      countryCallingCode: event.target.value
    })
  }

  submitMobile = (hideSendOtpForm) => {
    if (hideSendOtpForm) {
      this.setState({
        loading: true
      })
      if (this.state.enteredNumber && this.state.countryCallingCode) {
        sendOTP(this.state.enteredNumber, this.state.countryCallingCode)
          .then((res) => {
            this.setState({
              showsendOtpForm: false,
              loading: false
            })
          })
          .catch((err) => {
            this.setState({
              loading: false
            })
            this._addNotification(
              MessageType.ERROR,
              err.response.data.error_description
            )
          })
      } else {
        this.setState({
          loading: false
        })
        this._addNotification(
          MessageType.ERROR,
          'Enter Mobile Number & Country code'
        )
      }
    } else {
      this.setState({
        showsendOtpForm: true,
        enteredOtp: ''
      })
    }
  }

  verifyOtp = () => {
    if (this.state.enteredOtp.length === 6) {
      this.setState({
        loading: true
      })
      validateOtp(
        this.state.enteredOtp,
        this.state.enteredNumber,
        this.state.countryCallingCode
      )
        .then((response) => {
          if (response.data && response.data.status !== 'UNAUTHORIZED') {
            fetchAccessToken(response.data.username, response.data.password)
              .then((response) => {
                if (response) {
                  this.setState({
                    loading: false
                  })
                  this.props.onLoginSuccess(response)
                }
              })
              .catch((err) => {
                this.setState({
                  loading: false
                })
                this._addNotification(
                  MessageType.ERROR,
                  err.response.data.error_description ||
                    err.response.data.message
                )
              })
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
          this._addNotification(
            MessageType.ERROR,
            err.response.data.message || 'Error while validating OTP!'
          )
        })
    } else {
      this._addNotification(MessageType.ERROR, 'Enter 6 digit OTP')
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  /**
   * Used to show Notifications
   * @param  type Type of Notification
   * @param  msg   Message to Show
   */
  _addNotification(type, msg) {
    this._notificationSystem._addNotification(type, msg)
  }

  render() {
    return (
      <div>
        <div className={styles.form_group}>
          {this.state.showsendOtpForm && (
            <form>
              <Loader loading={this.state.loading} />
              {!this.state.loading && (
                <div>
                  <div className={styles.input_group}>
                    <input
                      type='text'
                      required
                      maxLength='5'
                      value={this.state.countryCallingCode}
                      className={styles.form_control_mobile}
                      placeholder='+91'
                      onChange={this.mobileCodeInputChangeHandler}
                    />
                    <input
                      type='number'
                      required
                      className={styles.form_control}
                      placeholder='Enter mobile number'
                      onChange={this.mobileInputChangeHandler}
                      value={this.state.enteredNumber}
                    />
                  </div>
                  <div className={styles.button_container}>
                    <button
                      className={styles.cstm_button}
                      type='button'
                      onClick={() => this.submitMobile(true)}
                    >
                      <div className={styles.btn_text}>Continue</div>
                    </button>
                  </div>
                </div>
              )}
            </form>
          )}
          <div>
            <div className=' body-container'>
              <NotificationComponent ref='notificationSystem' />
            </div>
          </div>
          {!this.state.showsendOtpForm && (
            <form>
              <Loader loading={this.state.loading} />
              {!this.state.loading && (
                <div>
                  <div className={styles.sign_in_text}>
                    Please enter the OTP sent to
                  </div>
                  <div className={styles.sign_in_text}>
                    {this.state.countryCallingCode} {this.state.enteredNumber}
                  </div>
                  <div className={styles.otp_row}>
                    <OtpInput
                      value={this.state.enteredOtp}
                      onChange={this.OtpInputChangeHandler}
                      numInputs={6}
                      separator={<span>-</span>}
                      inputStyle={{
                        width: '1.7rem',
                        fontSize: '1.4rem'
                      }}
                    />
                  </div>
                  <div className={styles.button_container}>
                    <button
                      type='button'
                      onClick={() => this.verifyOtp(true)}
                      className={styles.cstm_button}
                    >
                      <div className={styles.btn_text}>Verify</div>
                    </button>
                  </div>
                  <div className={styles.anchor_div}>
                    <div className={styles.anchor_text}>
                      Did not recieve OTP?
                      <span
                        className={styles.resendText}
                        onClick={() => this.submitMobile(false)}
                      >
                        Resend OTP
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    )
  }
}

export default MobileLogin
